// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"a91aa9bf","514":"90ba2865"}[chunkId] + ".chunk.css";
};